@if ((isLandingModule | async) !== true) {
  <div class="page-wrapper d-flex flex-column w-full">
    <app-header
      [showMenuItems]="!showPermanentSideMenu"
      [showUserMenuItems]="!isTabletScreen"
      (toggleSidenav)="sidenav.toggle()"
      class="sticky"
    >
    </app-header>
    @if (showPermanentSideMenu && !isTabletScreen) {
      <mat-drawer-container class="flex-auto w-full">
        <mat-drawer mode="side" [opened]="!isTabletScreen" class="d-flex flex-column">
          <app-sidebar> </app-sidebar>
        </mat-drawer>
        <mat-drawer-content>
          <router-outlet></router-outlet>
        </mat-drawer-content>
      </mat-drawer-container>
    }
    @if (!showPermanentSideMenu || isTabletScreen) {
      <mat-sidenav-container class="flex-auto w-full">
        <mat-sidenav class="d-flex flex-column" #sidenav [position]="mobileSideMenuPosition">
          <app-sidebar>
            <user-actions></user-actions>
          </app-sidebar>
        </mat-sidenav>
        <mat-sidenav-content class="matero-content fill">
          <router-outlet></router-outlet>
        </mat-sidenav-content>
      </mat-sidenav-container>
    }
    <app-footer class="footer"></app-footer>
  </div>
}
@if ((isLandingModule | async) === true) {
  <div style="width: 100%">
    <router-outlet></router-outlet>
  </div>
}
